import {
  SET_FILTER,
  UNSET_FILTER,
  ADD_STATUS_FILTER,
  REMOVE_STATUS_FILTER,
  SET_SORT,
} from "../actions/filters";

import { SORT } from "config/constants";

const initialState = {
  ordering: SORT.BY_LAST_UPDATED.value,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_FILTER:
      return { ...state, ...action.payload };
    /* eslint-disable no-case-declarations */
    case UNSET_FILTER:
      const { [action.payload]: foo, ...rest } = state; // eslint-disable-line no-unused-vars
      return rest;
    /* eslint-disable no-case-declarations */
    case ADD_STATUS_FILTER:
      if (state.status) {
        if (Array.isArray(action.payload)) {
          return { ...state, status: [...state.status, ...action.payload] };
        } else {
          return { ...state, status: [...state.status, action.payload] };
        }
      }
      return { ...state, status: [action.payload] };
    case REMOVE_STATUS_FILTER:
      let statusCopy = [...state.status]; // deep copy state.status
      if (statusCopy.includes(action.payload)) {
        statusCopy.splice(statusCopy.indexOf(action.payload), 1);
        if (statusCopy.length) {
          return { ...state, status: statusCopy };
        } else {
          const { status, ...rest } = state; // eslint-disable-line no-unused-vars
          return rest;
        }
      }
      return state;
    case SET_SORT:
      return { ...state, ordering: action.payload };
    default:
      return state;
  }
}
